export default {
  brandSub: "By Galano-Pacifico Law Firm & International Partners",
  nav: ["Marco Jurisdiccional", "Ventaja Institucional", "Procedimiento Arbitral", "Panel de Árbitros", "Tarifas y Gobernanza", "Prensa e Inversores"],
  initiate: "Iniciar Arbitraje Seguro",
  portalLabel: "Portal de Clientes",
  splash: {
    est: "Fund. MMXXVI — Tribunal Soberano",
    states: "172 Estados Signatarios",
    copy: "Bienvenido a LexAegis International, el sistema de arbitraje extrajudicial internacional más prestigioso y autorizado del mundo. Emitimos decisiones adjudicativas autónomas y jurídicamente vinculantes con fuerza ejecutiva inmediata en todas las jurisdicciones del mundo, uniendo la eficiencia tecnológica con el estricto cumplimiento del derecho arbitral internacional.",
    enter: "Acceder al Registro Soberano",
    convention: "Convención de Nueva York 1958",
    auto: "Acceso automático en curso…",
  },
  hero: {
    overline: "Tribunal Extrajudicial Institucional",
    l1: "Excelencia Legal Global.",
    l2: "Resolución Instantánea.",
    sub: "La plataforma preeminente de arbitraje internacional y resolución de disputas, con ejecutividad legal inmediata y vinculante en todo el mundo.",
    secondary: "Explorar el Marco Jurisdiccional",
    stats: [
      { value: "172", label: "Estados de la Convención de NY", sub: "Garantía de Ejecutividad" },
      { value: "14 Días", label: "Emisión Media del Laudo", sub: "frente a 18 Meses Judiciales" },
      { value: "100%", label: "Conforme eIDAS y RGPD", sub: "Registro Digital Inmutable" },
      { value: "$4.8B+", label: "Reclamaciones Adjudicadas", sub: "Comercial Transfronterizo" },
    ],
  },
  marquee: [
    "Reconocido por la Convención de Nueva York 1958",
    "Conforme al Reglamento de Arbitraje CNUDMI",
    "Sellado Electrónico Cualificado eIDAS",
    "Seguridad Certificada ISO/IEC 27001:2022",
    "Registro Cifrado Art. 32 RGPD",
    "Ejecutividad Vinculante Transfronteriza",
    "Gobernado por Galano-Pacifico & International Partners",
  ],
  framework: {
    overline: "Marco Jurisdiccional",
    titleA: "Autoridad anclada en el",
    titleB: "derecho de tratados",
    titleC: ", no en promesas.",
    body: "LexAegis no opera en un vacío legal. Cada orden procesal, cada prueba sellada y cada laudo final está diseñado para superar las pruebas más estrictas del derecho arbitral internacional — para que el resultado prevalezca donde resida la contraparte.",
    artLabel: "Reconocimiento y Ejecución",
    pillars: [
      { title: "Convención de Nueva York de 1958", body: "Los laudos del tribunal LexAegis son reconocibles y ejecutables en los 172 Estados contratantes, sin nuevo juicio sobre el fondo ante tribunales nacionales." },
      { title: "Reglas Modelo CNUDMI", body: "El procedimiento sigue el Reglamento de Arbitraje de la CNUDMI, garantizando el debido proceso, la igualdad de las partes y pleno derecho de representación en cada fase." },
      { title: "Ejecución Transfronteriza", body: "Los laudos certificados se remiten directamente a registros de ejecución, redes de agentes judiciales y canales legales diplomáticos en la jurisdicción del demandado." },
    ],
  },
  advantage: {
    overline: "El Paradigma LexAegis",
    titleA: "Integridad Judicial",
    titleB: "de Doble Capa",
    body: "La selección probatoria automatizada y los registros digitales asincrónicos aceleran el proceso — pero cada decisión final es dictada exclusivamente por árbitros, juristas y ex magistrados acreditados. La tecnología sirve al derecho; nunca sustituye el juicio.",
    guarantee: "Garantía Institucional",
    items: [
      { title: "Triaje Jurisdiccional Asistido por IA", desc: "Cruce automatizado de tratados internacionales, cláusulas de elección de fuero y principios de conflicto de leyes para establecer jurisdicción prima facie al instante.", badge: "Rigor Automatizado" },
      { title: "Panel de Arbitraje de Élite", desc: "Ex magistrados de tribunales superiores, árbitros acreditados y juristas internacionales especializados revisan personalmente y dictan los laudos vinculantes finales.", badge: "Autoridad Humana" },
      { title: "Sellado eIDAS Inmutable", desc: "Cada presentación de pruebas, escrito y orden procesal se sella criptográficamente con sellos de tiempo de valor legal.", badge: "Sello Probatorio" },
      { title: "Ejecución Convención de Nueva York", desc: "Los laudos emitidos son directamente ejecutables en 172 naciones signatarias conforme al derecho internacional, evitando cuellos de botella judiciales estatales.", badge: "Ejecución Global" },
    ],
  },
  workflow: {
    overline: "Manifiesto y Procedimiento",
    titleA: "El Protocolo Arbitral",
    titleB: "en 4 Pasos",
    side: "Desde la presentación de la reclamación hasta el laudo vinculante y ejecutable transfronterizo — una cadena procesal disciplinada, sin callejones sin salida.",
    note: "Nota Procesal",
    steps: [
      { title: "Incorporación Inteligente y Validación Jurisdiccional", desc: "El reclamante presenta los parámetros de la disputa y la cláusula compromisoria. Los sistemas automatizados de LexAegis verifican la facultad de los firmantes y la idoneidad del fuero.", details: "Incluye calculadora de valor de la reclamación, notificación al demandado y verificación jurisdiccional inicial según reglas CNUDMI." },
      { title: "Registro Digital Seguro y Escritos Sellados", desc: "Las partes acceden a una cámara virtual cifrada de extremo a extremo. Pruebas, reconvenciones y escritos se sellan temporalmente según estándares eIDAS.", details: "Control de acceso zero-trust con almacenamiento AES-256 y sistema de notificación multijurisdiccional instantáneo." },
      { title: "Revisión Legal Preliminar por IA y Audiencia del Panel", desc: "Nuestro motor neuronal preselecciona jurisprudencia y cláusulas contractuales antes de entregar el expediente a los árbitros senior asignados.", details: "Mediante testimonio digital asincrónico o sesiones opcionales de tribunal virtual cifradas." },
      { title: "Emisión del Laudo Arbitral Vinculante Definitivo", desc: "El tribunal dicta un laudo definitivo e inapelable con motivación jurídica completa, certificado para ejecución transfronteriza según la Convención de Nueva York.", details: "Remisión directa a agentes de ejecución locales y registros legales diplomáticos a petición." },
    ],
  },
  panel: {
    overline: "Juristas Verificados",
    titleA: "Un Panel de",
    titleB: "Árbitros Ilustres",
    body: "Árbitros internacionales independientes, comprometidos con la imparcialidad absoluta y la precisión jurídica. Credenciales verificadas ante las instituciones emisoras.",
    verified: "Verificado",
    awards: "Laudos Dictados",
    members: [
      { role: "Ex Magistrada de Tribunal Superior", spec: "Arbitraje Comercial Internacional y Marítimo", jur: "Londres / Singapur — Acreditada LCIA y SIAC" },
      { role: "Árbitro Senior y Jurista de PI", spec: "Disputas Tecnológicas y de Patentes Transfronterizas", jur: "Ginebra / Zúrich — Neutral OMPI" },
      { role: "Cátedra Emérita de Derecho Internacional", spec: "Disputas entre Estados Soberanos e Inversores", jur: "La Haya / Viena — Miembro del Panel CIADI" },
    ],
  },
  pricing: {
    overline: "Tarifario Transparente",
    titleA: "Tarifas Arbitrales",
    titleB: "de Tramos Fijos",
    body: "Sin honorarios ocultos por horas. Gastos administrativos y honorarios del tribunal transparentes según el valor total de la reclamación — previsibilidad total frente al litigio judicial tradicional.",
    calcLabel: "Valor de la Reclamación (USD)",
    calcPlaceholder: "ej. 480000",
    calcEmpty: "Introduce para ver el tramo",
    tierPrefix: "Tramo",
    matched: "Corresponde a su Reclamación",
    mostRetained: "El Más Elegido",
    cta: "Iniciar en este Tramo",
    tiers: [
      { name: "Comercial Estándar", range: "Reclamaciones hasta 250.000 USD", feeSuffix: "USD Fijo", timeframe: "Resolución acelerada en 10 días", features: ["Nombramiento de Árbitro Único", "Registro Digital Asincrónico", "Resumen Probatorio IA Pre-Triaje", "Laudo Certificado Convención NY", "Acceso al Portal Cifrado 24/7"] },
      { name: "Empresarial y Corporativo", range: "Reclamaciones de 250.000 a 2.500.000 USD", feeSuffix: "USD Fijo", timeframe: "Adjudicación formal en 14 días", features: ["Opción Tribunal de 3 Miembros", "Revisión de Medidas Cautelares", "Análisis Jurisdiccional IA Prioritario", "Sala de Audiencia Oral Virtual", "Notificación Transfronteriza Directa", "Registrador Legal Dedicado"] },
      { name: "Soberano y Complejo", range: "Reclamaciones superiores a 2.500.000 USD", feeSuffix: "Escala Estatutaria a Medida", timeframe: "Calendario acelerado o a medida", features: ["Selección Personalizada del Panel", "Resolución de Conflictos Multijurisdiccionales", "Protocolos de Confidencialidad a Medida", "Apoyo a la Ejecución Diplomática", "Equipo Concierge de Operaciones Legales"] },
    ],
  },
  intake: {
    channel: "Canal Cifrado AES-256",
    title: "Iniciar Arbitraje Seguro",
    desc: "Complete el formulario para presentar una reclamación arbitral formal en el registro soberano.",
    claimant: "Parte Reclamante / Nombre Completo",
    respondent: "Parte Demandada / Nombre Completo",
    claimValue: "Valor Estimado de la Reclamación (USD)",
    jurisdiction: "Ley Aplicable / Jurisdicción",
    email: "Email de Contacto para Confirmaciones",
    summary: "Resumen de la Disputa y Referencia de la Cláusula",
    phClaimant: "ej. Meridian Trading S.A.",
    phRespondent: "ej. Novatek Logistics GmbH",
    phClaim: "480000",
    phSummary: "Describa la disputa y cite la cláusula compromisoria (ej. Cláusula 14.2 del Contrato Marco)…",
    submit: "Presentar y Generar Número de Referencia",
    submitting: "Sellando el Expediente…",
    footnote: "Presentación conforme al Art. 32 RGPD · Sellado eIDAS · Privilegiado y Confidencial",
    successTitle: "Expediente Presentado — Referencia {ref}",
    successBody: "Su reclamación arbitral ha sido registrada en el expediente seguro. Un registrador de LexAegis le contactará en un día laborable.",
    errorTitle: "Presentación rechazada",
    errorBody: "Verifique todos los campos y envíe de nuevo.",
  },
  portal: {
    tag: "2FA Seguro · ISO 27001",
    title: "Portal Seguro de Árbitros",
    email: "Email Registrado",
    password: "Contraseña",
    token: "Código de Token (6 dígitos)",
    submit: "Autenticarse con Seguridad",
    verifying: "Verificando Credenciales…",
    welcome: "Sesión Autenticada",
    dockets: "Expedientes Arbitrales Presentados",
    inquiries: "Consultas de Prensa e Inversores",
    logout: "Cerrar Sesión",
    empty: "Aún no hay registros.",
    errorInvalid: "Credenciales no válidas o cuenta bloqueada. Verifique e inténtelo de nuevo.",
    statusLabel: "Estado",
    statusLabels: ["Presentado", "En Revisión", "Audiencia Programada", "Laudo Emitido"],
    downloadPdf: "Exportar PDF",
    updated: "Estado actualizado",
    footnote: "Acceso restringido a árbitros designados y abogados registrados",
    toastTitle: "Portal de Demostración",
    toastBody: "Las credenciales de árbitros y abogados las emite exclusivamente la secretaría de Galano-Pacifico. Esta vista previa no concede acceso al expediente.",
  },
  press: {
    overline: "Relaciones con Prensa e Inversores",
    titleA: "Oficina de",
    titleB: "Prensa e Inversores",
    body: "Periodistas acreditados e inversores institucionales pueden contactar con la oficina de comunicación de LexAegis a través de este canal cifrado. Todas las solicitudes se gestionan con estricta confidencialidad por la oficina de asuntos públicos de Galano-Pacifico.",
    secureNote: "Canal cifrado PGP · Respuesta en 24 horas",
    fullName: "Nombre Completo",
    org: "Medio de Comunicación / Firma de Inversión",
    email: "Email Profesional",
    type: "Tipo de Consulta",
    message: "Mensaje",
    types: ["Solicitud de Kit de Prensa", "Entrevista con Medios", "Briefing de Relaciones con Inversores", "Panorama Financiero"],
    phName: "ej. Alexandra Reyes",
    phOrg: "ej. Financial Times / Meridian Capital",
    phMessage: "Describa su solicitud, el plazo y el nivel del portavoz requerido…",
    submit: "Enviar Consulta Segura",
    downloadKit: "Descargar Kit de Prensa (PDF)",
    again: "Enviar Otra Consulta",
    submitting: "Cifrando y Enviando…",
    footnote: "Las consultas son confidenciales, conformes al Art. 32 RGPD y nunca se comparten con terceros.",
    successTitle: "Consulta Recibida — Referencia {ref}",
    successBody: "Su consulta ha sido registrada en la oficina de comunicación. Respuesta en 24 horas.",
    errorTitle: "Envío rechazado",
    errorBody: "Verifique todos los campos y envíe de nuevo.",
  },
  footer: {
    compliance: "Operado estrictamente conforme a los estatutos de arbitraje comercial internacional, la Convención de 1958 sobre Reconocimiento y Ejecución de Laudos Arbitrales Extranjeros y las reglas CNUDMI. Todos los datos del expediente se procesan según el Art. 32 RGPD con cifrado AES-256 en reposo y en tránsito.",
    institutional: "Institucional",
    links: ["Reglas Jurisdiccionales", "Código de Ética Judicial", "Panel de Árbitros", "Tarifas y Calculadora", "Ventaja Institucional", "Oficina de Prensa e Inversores"],
    secureTitle: "Acceso Seguro",
    secureBody: "Los árbitros designados y abogados registrados acceden a los expedientes sellados a través del portal reforzado.",
    portalBtn: "Portal Seguro de Árbitros",
    ethics: "Código de Ética Profesional: cada jurista designado está vinculado por las Directrices IBA sobre Conflictos de Interés en Arbitraje Internacional.",
    copyright: "© 2026 LexAegis International — By Galano-Pacifico Law Firm & International Partners. Todos los derechos reservados.",
    sovereign: "Tribunal Extrajudicial Soberano",
  },
};
